import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { AddPatientForm } from 'modules/Hcp';
import messages from '../../messages';
import * as constants from '../../constants';
const AddPatient = ({ onSetComponent, onSetHeaderMessage })=>{
    useEffect(()=>{
        onSetHeaderMessage(messages.addPatient.header);
        return ()=>onSetHeaderMessage();
    }, []);
    const onClose = (newPatient)=>{
        if (newPatient) {
            onSetComponent('DownloadSummary');
        }
    };
    return /*#__PURE__*/ _jsx(AddPatientForm, {
        modalId: constants.DOWNLOAD_DATA_MODAL,
        isAutoActivation: true,
        onClose: onClose
    });
};
export default AddPatient;
